import SubscriptionEndsBanner from "common/Home/Banners/SubscriptionEndsBanner";
import { BannerWrapper } from "common/Banner/Banner";
import React, { useMemo } from "react";
import styled from "styled-components";
import MobileAppBanner from "common/Home/Banners/MobileAppBanner";
import { isMobile } from "react-device-detect";
import SubscriptionExpiredBanner from "common/Home/Banners/SubscriptionExpiredBanner";
import { IS_WEB_VIEW, IS_WHOP } from "common/constants";
import TelegramWebAppBanner from "common/Home/Banners/TelegramWebAppBanner";
import StyledBanner from "common/Home/Banners/StyledBanner";
import DemoModeBanner from "common/Home/Banners/DemoModeBanner";
import FreemiumBanner from "common/Home/Banners/FreemiumBanner";
import { sharedLib } from "@shared/services/shared.service.ts";
import { useSelector } from "react-redux";
import { IS_TELEGRAM_WEB_APP } from "features/telegram/constants";
import {
  useClientsData,
  useExchangesMetadata,
} from "@shared/utils/hooks/misc.ts";
import { useBranding } from "@shared/utils/hooks/useBranding.ts";

const Banners = () => {
  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const { activeClientsData, getClientsListStatus } = useClientsData();
  const { getIsFree, getExchangesMetadataStatus } = useExchangesMetadata();
  const { isWhitelabel } = useBranding();

  const hasActiveFreeAccounts = useMemo(
    () => activeClientsData?.some((account) => getIsFree(account.exchange)),
    [activeClientsData, getIsFree]
  );
  const hasOnlyActiveFreeAccounts = useMemo(
    () =>
      !!activeClientsData?.length &&
      activeClientsData.every((account) => getIsFree(account.exchange)),
    [activeClientsData, getIsFree]
  );

  if (!user) return null;

  const showMobileAppBanner =
    !user.is_onboarding &&
    !IS_TELEGRAM_WEB_APP &&
    isMobile &&
    !user?.is_admin &&
    !user?.isExpired() &&
    !IS_WEB_VIEW &&
    !IS_WHOP &&
    !isWhitelabel;

  let subscriptionBanner: React.JSX.Element | undefined;
  if (user?.isExpired()) {
    subscriptionBanner =
      hasOnlyActiveFreeAccounts ||
      getClientsListStatus.isLoading ||
      getExchangesMetadataStatus.isLoading ? undefined : (
        <SubscriptionExpiredBanner
          user={user}
          showCloseButton={hasActiveFreeAccounts}
        />
      );
  } else {
    subscriptionBanner = <SubscriptionEndsBanner user={user} />;
  }

  return (
    <Wrapper>
      {!user.is_sub_user && (
        <>
          <StyledBanner />
          <FreemiumBanner />
        </>
      )}
      <DemoModeBanner />
      {showMobileAppBanner && <MobileAppBanner />}
      {IS_TELEGRAM_WEB_APP && !isMobile && <TelegramWebAppBanner />}
      {!user.is_sub_user && subscriptionBanner}
    </Wrapper>
  );
};

export default Banners;

const Wrapper = styled.div`
  ${BannerWrapper} {
    &:not(:last-of-type) {
      border-bottom: ${(p) => p.theme.borders.medium};
    }
  }
`;
